import React, { useCallback, useEffect, useState } from "react";
import { Dayjs } from "dayjs";
import {
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Box,
  Stack,
  useMediaQuery,
  styled,
  alpha,
  InputBase,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useLocation, useNavigate } from "react-router-dom";
import { SyncIcon, AddIcon } from "../common/iconsData";
import { OrderRowType, TabCol } from "../components/features/orders/OrderData";
import {
  Title,
  Card,
  DatePickerEl,
  CustomTabPanel,
  CustomDataTable,
} from "../components/ui/uiImport";
import useOrderFilter, {
  shipmentFilter,
} from "../components/features/orders/useOrderFilter";
import { useServiceDrawer } from "../components/features/orders/useServiceDrawer";
import { fetchAllOrder } from "../components/features/orders/orderApi";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import MultipleOrderAssignDrawer from "../components/features/orders/MultipleOrderAssignDrawer";
import { FilterAlt } from "@mui/icons-material";
import { DataTableForMobile } from "../components/features/orders/OrderTableMobile";
import { OrderFilter } from "../components/features/orders/OrderFilterDrawer";
import { StyledButton } from "../components/ui/StyledButton";
import MultipleOrderScheduleDrawer from "../components/features/orders/MultipleOrderScheduleDrawer";
import MultipleOrderBulkDownloadDrawer from "../components/features/orders/MultipleOrderBulkDownloadDrawer";

import Paper from "@mui/material/Paper";



const Order = () => {

//   // --- Styled Components ---
//   const Search = styled("div")(({ theme }) => ({
//     position: "relative",
//     borderRadius: theme.shape.borderRadius,
//  backgroundColor: '#0a31b076',
// '&:hover': {
//   backgroundColor: '#0a31b0b3', // slightly darker on hover
// },

//     display: "flex",
//     alignItems: "center",
//     padding: "0 8px",
//     // width: "100%",
//     maxWidth: 400,
//   }));
  
//   const SearchIconWrapper = styled("div")(() => ({
//     padding: 8,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   }));
  
//   const StyledInputBase = styled(InputBase)(({ theme }) => ({
//     color: "white",
//     flex: 1,
//     input: {
//       padding: theme.spacing(1),
//       paddingLeft: `calc(1em + ${theme.spacing(2)})`,
//       width: "100%",
//     },
//   }));

  const matches = useMediaQuery("(min-width:600px)");
  const [awbInput, setAwbInput] = useState("");
  const { syncOrder, setSyncOrder } = useServiceDrawer();
  const [openFilter, setOpenFilter] = useState(false);
  const [orders, setOrders] = useState<OrderRowType[]>([]);
  const [selectedId, setSelectedId] = useState<
    GridRowSelectionModel | number[]
  >([]);
  const [openMultiple, setOpenMultiple] = useState(false);
  const [openMultipleBooked, setOpenMultipleBooked] = useState(false);
  const [openMultipleDownload, setOpenMultipleDownload] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const {
    startDate,
    endDate,
    page,
    shipment,
    activeTab,
    defaultTab,
    setTotalRow,
    handleDateChange,
    handleShipmentChange,
    handleTabChange,
    handleTransportChange,
    shipmentParams,
    totalRow,
    updatePage,
    serviceData,
    transport,
  } = useOrderFilter();

  const fetchAllOrderMethod = useCallback(() => {
    fetchAllOrder(
      startDate as Dayjs,
      endDate as Dayjs,
      page,
      shipmentFilter[shipment].value,
      defaultTab[activeTab].filter
    )
      .then((data) => {
        let allData: any[] = [];
        allData = [...data.data.data.data];
        setTotalRow(data?.data?.data?.pages_count);
        setOrders(allData);
        setSelectedId([]);
      })
      .catch((error) => {
        setOrders([]);
        setSelectedId([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, page, shipment, activeTab, defaultTab]);

  // const { totalRows, isLoading, error, orders } = useOrders(
  //   startDate as Dayjs,
  //   endDate as Dayjs,
  //   page,
  //   shipmentFilter[shipment].value,
  //   defaultTab[activeTab].filter
  // );
    const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (  searchTerm.trim() !== "") {
      // onSearch(searchTerm.trim());
      navigate(`/tracking-shipment/${searchTerm.trim()}`)
      setSearchTerm("")
    }
  };
  
  // const handleKeyDown = (e:any) => {
  //   if (e.key === "Enter") handleSearch();
  // };

  useEffect(() => {
    setTotalRow(1);
    fetchAllOrderMethod();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchAllOrderMethod, syncOrder]);

  const showFilterData =
    transport !== "All"
      ? orders?.filter((order) => order.vendor === transport)
      : orders;

  const bulkActionHandler = (e: GridRowSelectionModel) => {
    setSelectedId(e);
  };

  const selectedData = orders?.filter((el) => {
    return selectedId.includes(el.id);
  });
  const username = localStorage.getItem("hipship-username") || "User";
  const isUser = username === "Cipla";


  return (
    <>
      <Title title="Order" />
      <Card>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap={"wrap"}
          rowGap={"20px"}
          columnGap={"20px"}
          marginBottom={"40px"}
        >
          <div className="order-filters">
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              flexWrap={"wrap"}
              columnGap={"20px"}
              rowGap={"20px"}
            >
              <DatePickerEl
                width="160px"
                defaultDate={startDate}
                handleChange={(time) => handleDateChange(time, "start")}
                label="From"
              />
              <DatePickerEl
                width="160px"
                defaultDate={endDate}
                handleChange={(time) => handleDateChange(time, "end")}
                label="To"
              />
              {!isUser &&(<>
              <FormControl sx={{ minWidth: 150 }} size="small">
                <InputLabel id="demo-select-small-label">Vendor</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={transport ?? "All"}
                  label="Vendor"
                  onChange={handleTransportChange}
                >
                  {serviceData?.map((el, index) => {
                    return (
                      <MenuItem key={index} value={el}>
                        {el}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              </>)}

              <FormControl sx={{ minWidth: 150 }} size="small">
                <InputLabel id="shipment-select-small-label">
                  Shipment
                </InputLabel>
                <Select
                  labelId="shipment-select-small-label"
                  id="shipment-select-small"
                  value={shipment.toString()}
                  label="Shipment"
                  onChange={handleShipmentChange}
                >
                  {shipmentFilter.map((el, index) => {
                    return (
                      <MenuItem key={index} value={index}>
                        {el.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Stack>
          </div>
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"20px"}
            rowGap={"20px"}
          >
            <div className="order-filter-button">
              <Button
                onClick={() => setOpenFilter(true)}
                sx={{
                  padding: "6px 20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "12px",
                }}
                variant="contained"
              >
                <FilterAlt
                  sx={{
                    fontSize: "16px",
                  }}
                />
                <p>Filters</p>
              </Button>
            </div>

            <Paper
              component="form"
              sx={{
                p: "2px 8px",
                display: "flex",
                alignItems: "center",
                width: 220,
                height: 40,
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "white",
              }}
              onSubmit={(e) => {
                e.preventDefault();
                const matchedOrder = orders.find(
                (order) => order.awb === awbInput.trim()
              );
              if (matchedOrder) {
                navigate(`/tracking/${matchedOrder.id}`);
              } else {
              alert("AWB not found");
              }
              }}
            >
            <SearchIcon sx={{ color: "#888", mr: 1 }} />
            <InputBase
            sx={{ ml: 1, flex: 1, fontSize: "14px" }}
            placeholder="Search AWB"
            value={awbInput}
            onChange={(e) => setAwbInput(e.target.value)}
            />
            </Paper>
            {!isUser && (
            <>

            <StyledButton
              sx={{
                padding: "6px 20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                fontSize: "12px",
              }}
              variant="contained"
              disabled={!(selectedId.length > 0)}
              onClick={() =>
                activeTab=== 2? setOpenMultipleDownload(true):
                activeTab === 0
                  ? setOpenMultiple(true)
                  : setOpenMultipleBooked(true)
              }
            >
              <p>Bulk&nbsp;Action</p>
            </StyledButton>
            <StyledButton
              sx={{
                padding: "6px 20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                fontSize: "12px",
              }}
              variant="contained"
              onClick={() =>
                navigate("/order/add-order", {
                  state: { prevurl: location.pathname + location.search },
                })
              }
            >
              <AddIcon
                sx={{
                  fontSize: "16px",
                }}
              />
              <p>Add&nbsp;Order</p>
            </StyledButton>
            <StyledButton
              sx={{
                paddingLeft: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                fontSize: "12px",
              }}
              variant="outlined"
              onClick={setSyncOrder}
            >
              <SyncIcon
                sx={{
                  fontSize: "16px",
                }}
              />
              <p>Sync&nbsp;Order</p>
            </StyledButton>
            </>)}
          </Stack>
        </Stack>

        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e: React.SyntheticEvent<Element, Event>, number: any) =>
              handleTabChange(e, number, shipmentParams)
            }
            variant="scrollable"
          >
            {defaultTab.map((orderTab, index) => {
              return <Tab key={index} label={orderTab.label} />;
            })}
          </Tabs>
        </Box>

        <CustomTabPanel value={activeTab} index={activeTab}>
          {matches ? (
            <CustomDataTable
              page={page}
              totalRow={totalRow}
              updatePage={updatePage}
              rows={showFilterData}
              columns={TabCol[shipment][activeTab].column}
              checkBox={
                (activeTab === 0 || activeTab === 1 || activeTab === 2) &&
                shipment === 0
                  ? true
                  : false
              }
              onRowSelectionModelChange={bulkActionHandler}
              total={showFilterData.length ?? 0}
              wantExcel={false}
            />
          ) : (
            <DataTableForMobile
              rows={showFilterData}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              checkBox={(activeTab === 0 || activeTab === 1 || activeTab === 2 )&& shipment === 0 ? true : false}
              page={page}
              totalRow={totalRow}
              updatePage={updatePage}
            />
          )}
        </CustomTabPanel>
      </Card>

      <MultipleOrderAssignDrawer
        ids={selectedId}
        handleClose={() => {
          setOpenMultiple(false);
          setSyncOrder();
        }}
        open={openMultiple}
        data={selectedData}
      />

      <MultipleOrderScheduleDrawer
        ids={selectedId}
        handleClose={() => {
          setOpenMultipleBooked(false);
          setSyncOrder();
        }}
        open={openMultipleBooked}
        data={selectedData}
      ></MultipleOrderScheduleDrawer>
      
      <MultipleOrderBulkDownloadDrawer
        ids={selectedId}
        handleClose={() => {
          setOpenMultipleDownload(false);
          setSyncOrder();
        }}
        open={openMultipleDownload}
        data={selectedData}
      ></MultipleOrderBulkDownloadDrawer>

      <OrderFilter
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        startDate={startDate}
        endDate={endDate}
        shipment={shipment}
        transport={0}
        handleDateChange={handleDateChange}
        handleShipmentChange={handleShipmentChange}
        handleTransportChange={handleTransportChange}
      />
    </>
  );
};

export default Order;
